import type { TypedMyHotelPhotogallery } from './-MyHotelPhotogallery';
import RawMyHotelPhotogallery from './MyHotelPhotogallery.vue';
export * from './-MyHotelPhotogallery';
export const MyHotelPhotogallery = RawMyHotelPhotogallery as typeof TypedMyHotelPhotogallery;
